import { useState } from "react";

const useCalendlyModal = () => {
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);

  const openCalendlyModal = () => {
    setIsCalendlyModalOpen(true);
  };

  const closeCalendlyModal = () => {
    setIsCalendlyModalOpen(false);
  };

  return {
    isCalendlyModalOpen,
    openCalendlyModal,
    closeCalendlyModal,
  };
};

export default useCalendlyModal;
